import React from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import HeroAbout from './HeroAbout';
import Excellence from './Excellence';
import Founder from './Founder';
import UniqueAbout from './CompanyStory';
import DevanantaHero from './Mission';
import SustanableGreener from './Press';

const About: React.FC = () => {
  return (
    <div className="w-full bg-black min-h-screen">
      <Navbar />
      <HeroAbout />
      <UniqueAbout />
      <DevanantaHero />
      <SustanableGreener />
      <Founder />
      <Excellence />
      <Footer />
    </div>
  );
};

export default About;